import { TargetSizeService } from "../service/asyncBatchTargetSizeService";
import * as validations from "../utils/validations";

export class TargetSizeFunctions {
  fnBurgissCalcTargetSize(portfolioId: any[][], endDate: any, currency: string, uniqueCellId: string) {
    const portfolioIdvalue = validations.getSingleOrRangeValues(portfolioId);

    if (String(portfolioIdvalue) == "Error") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    if (String(portfolioIdvalue) == "Errinvesid") {
      return "#INVALIDPARAMETERS - Invalid formavt for ID parameter";
    }
    endDate = validations.isValidDate(endDate);
    if (endDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    if (endDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    endDate = new Date(endDate).toLocaleDateString();

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    return new TargetSizeService().burgissCalcTargetSize(
      portfolioId,
      endDate,
      currency,
      alternateCurrrency,
      uniqueCellId
    );
  }
}
